<template>
  <div class="ny-form-item__radio">
    <el-form-item :class="{ 'is-required': required }" :label="label" :prop="prop">
      <el-radio-group
        class="is-half"
        :class="{ 'is-multiple': multiple, 'is-large': large }"
        v-model="currentValue"
        v-bind="$attrs"
      >
        <el-radio
          v-for="item in data"
          :key="item[keyValue[0]]"
          :label="item[keyValue[0]]"
          :disabled="$attrs.disabled || disabledData.length > 0 && disabledData.indexOf(item[keyValue[0]]) === -1"
        >{{item[keyValue[1]]}}</el-radio>
      </el-radio-group>
    </el-form-item>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'NyFormItemRadio',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true
    },
    data: {
      type: Array,
      default: () => []
    },
    required: Boolean,
    label: String,
    prop: String,
    multiple: Boolean,
    large: Boolean,
    keyValue: {
      type: Array,
      default: () => ['value', 'name']
    },
    disabledData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentValue: this.value
    }
  },
  watch: {
    value (newVal) {
      this.currentValue = newVal;
    },
    currentValue (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>
<style lang="scss">
@include b(ny-radio) {
  .el-radio-group {
    @include is(half) {
      .el-radio {
        width: 50%;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
